import Connector, { takeQuery } from '../../agent';
import types from './types';

const Risks = {
  calculateChemRiskLevel: ({ chemRiskLevelRequestDto }) =>
    Connector.api.post('/riskCalculations/calculateChemRiskLevel', chemRiskLevelRequestDto),
  calculateEnvRisk: ({ envRiskRequestDto }) =>
    Connector.api.post('/riskCalculations/calculateEnvRisk', envRiskRequestDto)
};

const riskSagas = [
  takeQuery(types.CALCULATE_CHEM_RISK_LEVEL, Risks.calculateChemRiskLevel),
  takeQuery(types.CALCULATE_ENV_RISK, Risks.calculateEnvRisk)
];

export default riskSagas;
